import { render, staticRenderFns } from "./uploadItem.vue?vue&type=template&id=70e184a5&"
import script from "./uploadItem.vue?vue&type=script&lang=js&"
export * from "./uploadItem.vue?vue&type=script&lang=js&"
import style0 from "./uploadItem.vue?vue&type=style&index=0&id=70e184a5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports